export default class User {
  constructor(firstName, lastName, email, date, role, phoneNumber,photo, maxStudents) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.date = date;
    this.role = role;
    this.phoneNumber = phoneNumber;
    this.photo = photo;
    this.maxStudents = maxStudents;
  }

  isValid() {
    var result = this.firstName && this.lastName && this.email;

    return result;
  }
}